'use client';

import { NextIntlClientProvider, useMessages, useLocale } from 'next-intl';
import type { PropsWithChildren } from 'react';

/**
 * A wrapper component that accesses messages from the server context
 * and creates a new client-side NextIntlClientProvider to ensure
 * client components have proper access to translations.
 */
export function TranslationProviderWrapper({
  children
}: PropsWithChildren) {
  // Get messages from the current Next.js context
  const messages = useMessages();
  // Get the current locale
  const locale = useLocale();

  // Create a new provider for the client components
  return <NextIntlClientProvider messages={messages} locale={locale} data-sentry-element="NextIntlClientProvider" data-sentry-component="TranslationProviderWrapper" data-sentry-source-file="translation-provider-wrapper.tsx">
      {children}
    </NextIntlClientProvider>;
}